import styled, { css } from 'styled-components'

const iconPosition = ({ element }) => {
  if (element === 'accordion') {
    return css`
      top: -12px;
      left: 16px;
    `
  } else if (element === 'dropdownMenu') {
    return css`
      top: -64px;
      right: -16px;
    `
  }
}

export const Pulse = styled.div`
  height: 24px;
  width: 24px;
  background: #e11900;
  position: absolute;
  margin: auto;
  border-radius: 50%;
  display: flex;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;  
  

  ${iconPosition}
  :before,
  :after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: #e11900;
    border-radius: 50%;
    z-index: -1;
    opacity: 0.7;
  }

  :before {
    animation: pulse 2s ease-out infinite;
  }

  :after {
    animation: pulse 2s 1s ease-out infinite;
  }
`
